import { Box, BoxProps, SxProps } from "@mui/material";
import { FC, ReactNode } from "react";

interface PageLayoutProps extends BoxProps {
  header?: ReactNode;
  headerSx?: SxProps;

  bottomButton?: ReactNode;
  bottomButtonSx?: SxProps;

  children: ReactNode;
  contentSx?: SxProps;
}

const PageLayout: FC<PageLayoutProps> = ({
  sx,
  header,
  headerSx,
  bottomButton,
  bottomButtonSx,
  children,
  contentSx,
  ...props
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        ...sx,
      }}
      {...props}
    >
      {header && <Box sx={{ flexShrink: 0, ...headerSx }}>{header}</Box>}

      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          overflowX: "hidden",
          minHeight: 0,
          ...contentSx,
        }}
      >
        {children}
      </Box>

      {bottomButton && (
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            paddingBottom: "18px",
            width: "100%",
            left: 0,
            paddingX: "8px",
            zIndex: 100,
            ...bottomButtonSx,
          }}
        >
          {bottomButton}
        </Box>
      )}
    </Box>
  );
};

export default PageLayout;
